import { VALIDATION_MESSAGES, REGEX_PATTERNS } from 'eebac/constants';


const FIELDS = {
    specifications: {
        type: "input",
        label: "Specifications",
        rows : 4,
        isRequired: true,
        isMultiline:  true,
        xs:12,
        lg:9,
        sm:12,
        md:12,
        validations: {
            presence: { allowEmpty: false, message: VALIDATION_MESSAGES.REQUIRED },
            length: {
                minimum: 2, maximum: 1000
            }
        }
    },
    about: {
        type: "input",
        label: "Profile",
        rows : 4,
        isMultiline:  true,
        disabled: true,
        xs:12,
        lg:9,
        sm:12,
        md:12
    }
};

export default FIELDS;